import { Grid, MenuItem, Select, TextField } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../helpers/generateUrl";
import {
  getCities, getClient, getDealer, getInstitute, getSampleAccessioning
} from "../../actions/GenomicsResearchAction";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    input: {
      padding: "1px",
    },
    text: { color: "black" },
  })
);
interface Props {
  getCities: any;
  cities: any;
  getSampleAccessioning: any;
  getDealer: any;
  dealer: any;
  getClient: any;
  client: any;
  getInstitute: any;
  institute: any;
}
const StopsPlace: React.FC<Props> = ({
  getCities,
  cities,
  getSampleAccessioning,
  getDealer,
  dealer,
  getClient,
  client,
  getInstitute,
  institute,

}) => {
  const history = useHistory();
  const timer = useRef<any>(0);
  const [sampleRecevied, setSamplerecived] = React.useState<any>("");
  const [projectStatus, setprojectStatus] = useState<any>("");
  const [page, setPage] = useState(0);
  const [name, setName] = useState<any>("");
  const [sampleStatus, setSampleStatus] = useState<any>("none");
  const [dealers, setDealers] = useState<any>();
  const [dealersName, setDealersName] = useState<any>("");
  const [clientName, setClientgName] = useState<any>("");
  const [clients, setClients] = React.useState<any>();
  const [insName, setInsName] = useState<any>("");
  const [instituteName, setInstituteName] = useState<any>();

  const filterSampleAssData = (e: any) => {
    const body: any = {
      isProjectCreated: projectStatus,
      inspectionStatus: sampleStatus,
      createdAt: sampleRecevied,
      search: name,
      scientist: clients,
      institute: instituteName,
      dealer: dealers,
    };
    const url = generateGenomicsResearchUrl(body).substring(2);
    getSampleAccessioning(url);
    setPage(0);
  };
  return (
    <form style={{ width: "100%", marginLeft: 14 }} onSubmit={filterSampleAssData}>
      <Grid container spacing={2} style={{ marginTop: 10 }}>
        <Grid
          container
          spacing={1}
          direction="row"
          style={{ marginTop: 10 }}
        >

          <Grid item xs={12} sm={4} md={2}>
            <Select
              className="input"
              label="Project Creation Status"
              fullWidth
              aria-required
              variant="outlined"
              value={projectStatus || "none"}
              style={{ width: "100%", height: "40px" }}
              onChange={(e) => setprojectStatus(e.target.value as string)}
              onKeyDown={(e)=>e.keyCode === 13?filterSampleAssData(e):""}                          
            >
              <MenuItem value="none" disabled>Select Project Status </MenuItem>
              <MenuItem value="false">Pending </MenuItem>
              <MenuItem value="true">Created</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              disablePortal
              id="client_name"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setClients(obj._id);
                }
              }}
              defaultValue={
                { _id: "", name: clientName }
              }
              options={client?.results || []}
              blurOnSelect
              disableClearable={clientName===""}
              disableCloseOnSelect
              getOptionLabel={(option: any) => `${option?.name}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getClient(`name=${newInputValue}`);
                }, 1000);
                setClientgName(newInputValue);
              }}
              renderInput={(params) =>
                <TextField
                  {...params}
                  className="input"
                  label="Client"
                  variant="outlined"
                  placeholder="Search Client Name"
                  fullWidth
                />}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              disablePortal
              id="Institute"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setInstituteName(obj._id);
                }
              }}
              defaultValue={
                { id: "", name: insName }
              }
              options={institute.results || []}
              blurOnSelect
              disableClearable={insName === ""}
              disableCloseOnSelect
              getOptionLabel={(option: any) => `${option?.name}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getInstitute(`search=${newInputValue}`);
                }, 1000);
                setInsName(newInputValue);
              }}
              renderInput={(params) =>
                <TextField
                  {...params}
                  className="input"
                  label="Institute Name"
                  placeholder="Search Institute Name"
                  variant="outlined"
                  fullWidth
                />}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Autocomplete
              disablePortal
              id="Dealer"
              onChange={(event, newValue) => {
                if (newValue) {
                  let obj = JSON.parse(JSON.stringify(newValue, null, ""));
                  setDealers(obj._id);
                }
              }}
              defaultValue={
                { id: "", firmName: dealersName }
              }
              options={dealer.results || []}
              blurOnSelect
              disableClearable={dealers === "" || dealersName===""}
              disableCloseOnSelect
              getOptionLabel={(option: any) => `${option?.firmName}`}
              onInputChange={(event, newInputValue) => {
                clearTimeout(timer.current);
                timer.current = setTimeout(() => {
                  getDealer(`search=${newInputValue}`);
                }, 1000);
                setDealersName(newInputValue);
              }}
              renderInput={(params) =>
                <TextField
                  {...params}
                  className="input"
                  label="Dealer Name"
                  placeholder="Search Dealer name"
                  variant="outlined"
                  fullWidth
                />}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Select
              className="input"
              label="Sample Status"
              fullWidth
              aria-required
              variant="outlined"
              value={sampleStatus || "none"}
              style={{ width: "100%", height: "40px" }}
              onChange={(e) => setSampleStatus(e.target.value as string)}
              onKeyDown={(e)=>e.keyCode === 13?filterSampleAssData(e):""}                          
            >
              <MenuItem value="none" disabled>Select Sample Status </MenuItem>
              <MenuItem value="Pass">Pass </MenuItem>
              <MenuItem value="Fail">Reject</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <TextField
              name="expiry_date"
              type="date"
              value={sampleRecevied}
              className="input"
              label="Sample Recived Date"
              variant="outlined"
              onChange={(e) => setSamplerecived(e.target.value as string)}
              style={{ width: "100%" }}
              onKeyDown={(e)=>e.keyCode === 13?filterSampleAssData(e):""}                          
            />
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={filterSampleAssData}
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={4} md={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => history.go("/dashboard/gnre/samples")}
            >
              Reset
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
const mapStateToProps = (state: any) => ({
  cities: state.GenomicsCAReducer.cities,
  samplesAccessioning: state.GenomicsCAReducer.samplesAccessioning,
  dealer: state.GenomicsCAReducer.dealer,
  client: state.GenomicsCAReducer.client,
  institute: state.GenomicsCAReducer.institute,

});
export default connect(mapStateToProps, {
  getCities,
  getSampleAccessioning,
  getDealer,
  getClient,
  getInstitute,

})(StopsPlace);
